import { useMutation } from "react-query";
import { useContext } from "react";
import { PatientBookingContext } from "./context/PatientBookingProvider";
import usePopup from "../../../hooks/usePopup";
import { initialBooking } from "./types";
import { saveAppointmentsV2 } from "./services";
import { getBookingResponseStringMessages } from "./bookingResponseMessages";

const useBookingSave = (
  callOnSuccess?: (savedBooking: any) => void
) => {
  const { setOpen, setRefetch, setTimeSlot, setEditDetails } = useContext(
    PatientBookingContext
  );
  const { showSnackbar } = usePopup();

  return useMutation(saveAppointmentsV2, {
    onSuccess: (result) => {
      if (result.responseIndicator === "success") {
        setOpen(false);
        setEditDetails(null);

        // ✅ IMPORTANT: do NOT refetch
        setRefetch(true);

        setTimeSlot(initialBooking.timeSlot);

        const responseMessages = getBookingResponseStringMessages(
          result.response,
        );

        if (responseMessages.length > 0) {
          responseMessages.forEach((message) => {
            showSnackbar({
              message,
              variant: "warning",
              open: true,
              duration: 6000,
            });
          });
        } else {
          showSnackbar({
            message: result.responseMessage,
            variant: "success",
            open: true,
            duration: 2000,
          });
        }

        // ✅ Pass saved booking back to calendar
        if (callOnSuccess && result.response) {
          callOnSuccess(result.response);
        }
      } else {
        showSnackbar({
          message: result.responseMessage,
          variant: "warning",
          open: true,
          duration: 2000,
        });
      }
    },
    onError: (error: any) => {
      showSnackbar({
        message:
          error?.response?.data?.responseMessage || "Something went wrong !",
        variant: "warning",
        open: true,
        duration: 2000,
      });
    },
  });
};

export default useBookingSave;
